<div class="flex flex-col" id="home-wrapper">
  <app-breadcrumb
    [path]="'COMPONENT.SIDEBAR.organization' | translate"
    [station]="getSelectedStationName()"
    [title]="'COMPONENT.SIDEBAR.organization' | translate"
    [filter]="activeFilter?.value"
  >
    <div class="flex justify-between items-center w-full">
      <div class="block justify-start w-full"></div>
      <!-- Presentation Mode -->
      <div
        class="presentation-wrapper"
        [class.active]="toggleState"
        (click)="handleToggle(!toggleState)"
      >
        <span class="presentation-label">{{ 'PRESENTATION.mode' | translate }}</span>
        <mat-icon [ngClass]="toggleState ? 'text-[var(--primary-color)]' : 'text-gray-500'">
          {{ toggleState ? 'visibility' : 'visibility_off' }}
        </mat-icon>
      </div>
    </div>
  </app-breadcrumb>
  <div class="flex flex-col w-full justify-between select-box">
    <!-- #region Filter Selection -->
    <div class="flex flex-row items-center justify-between">
      <div class="flex items-center">
        <mat-select
          [value]="getSelectedStationId()"
          (selectionChange)="onStationSelectionChange($event)"
          [hideSingleSelectionIndicator]="true"
          name="stationList"
          class="w-48 bg-white !font-light filter-item standalone-select"
        >
          <mat-select-trigger>
            {{ getSelectedStationName() }}
          </mat-select-trigger>

          <mat-option *ngFor="let list of caseLists" [value]="list.listIdentifier.name">
            {{ list.listIdentifier?.name }}
          </mat-option>
        </mat-select>
      </div>
      <div class="flex flex-row w-full">
        <div
          (click)="handleSelectedFilter(filter)"
          *ngFor="let filter of filterOptions"
          [ngClass]="{
            '!bg-[var(--primary-color)]': filter.selected,
            '!text-white': filter.selected,
          }"
          class="bg-white w-48 items-end text-center flex flex-row justify-start font-light text-sm cursor-pointer hover:bg-[var(--color-background-primary-color-hover)] filter-item"
        >
          <div>{{ filter.value }}</div>
        </div>
      </div>

      <!-- Right side: Sort and Search -->
      <div class="flex flex-row w-half gap-2">
        <!-- Sorting Area -->
        <mat-select
          [hideSingleSelectionIndicator]="true"
          [value]="sortOptions[0]"
          class="w-48 bg-white !font-light filter-item"
        >
          <mat-option
            (click)="onSelectSortOption(sort)"
            *ngFor="let sort of sortOptions"
            [value]="sort"
            class="!flex !items-center !justify-between !flex-row-reverse !gap-2 !font-light"
          >
            <span>{{ sort.value }}</span>
            <mat-icon *ngIf="sort.order === 'ASC' && sort.selected" class="!m-0"
              >arrow_upward</mat-icon
            >
            <mat-icon *ngIf="sort.order === 'DESC' && sort.selected" class="!m-0"
              >arrow_downward</mat-icon
            >
          </mat-option>
        </mat-select>

        <!-- Searching Area -->
        <div class="flex flex-row justify-between items-center bg-white search-container">
          <input
            (input)="searchValue($event.target)"
            [placeholder]="'COMPONENT.PAGE_WORKFLOW.search_input_placeholder' | translate"
            class="font-light search-input"
            matInput
            type="search"
          />
          <mat-icon>search</mat-icon>
        </div>
      </div>
    </div>
    <!-- #endregion -->
  </div>

  <!-- #region Patient-Table -->
  <div class="table-container">
    <table [dataSource]="dataSource" class="home-patient-list" mat-table>
      <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
        <th *matHeaderCellDef mat-header-cell>{{ column | translate }}</th>
        <td
          *matCellDef="let element"
          class="hover:!bg-[var(--color-background-primary-color-hover)] !p-0"
          mat-cell
        >
          <ng-container *ngIf="element" [ngSwitch]="column">
            <!-- General Information -->
            <div
              *ngSwitchCase="
                translatedColumns['COMPONENT.PAGE_WORKFLOW.column_general_information']
              "
              [routerLink]="['/patient-details', element?.patient_details.case.related_case_id]"
              class="general-info-cell w-full h-full !cursor-pointer"
            >
              <!-- Patient info -->
              <app-home-patient-basic-info
                [disableDiagnosis]="true"
                [patient]="element"
                class="patient-list-basic h-full !px-2"
              ></app-home-patient-basic-info>

              <div class="icon-container">
                <mat-icon
                  *ngIf="toggleState"
                  [ngClass]="{
                    'opacity-30': !isPatientViewed(element),
                    'opacity-100': isPatientViewed(element),
                  }"
                  class="text-[var(--primary-color)] transition-opacity duration-300"
                >
                  visibility
                </mat-icon>
              </div>
            </div>
            <!-- Task -->
            <div
              *ngSwitchCase="translatedColumns['COMPONENT.PAGE_WORKFLOW.column_task']"
              class="w-full h-full flex items-center cursor-pointer"
            >
              <app-home-patient-tasks
                [patient]="element"
                class="w-full h-full !px-2"
              ></app-home-patient-tasks>
            </div>

            <!-- Goal Date -->
            <div
              *ngSwitchCase="translatedColumns['COMPONENT.PAGE_WORKFLOW.column_goal_date']"
              class="goal-date-cell w-full h-full flex items-center cursor-default !px-2"
            >
              {{ element?.tasks[0]?.data.goalDateOn | date: 'short' }}
            </div>

            <!-- Contractor -->
            <div
              *ngSwitchCase="translatedColumns['COMPONENT.PAGE_WORKFLOW.column_contractor']"
              class="w-full h-full flex items-center cursor-default !px-2"
            >
              {{ element?.tasks[0]?.data.contractor?.name }}
              {{ element?.tasks[0]?.data.contractor?.surname }}
            </div>

            <!-- Status -->
            <div
              *ngSwitchCase="translatedColumns['COMPONENT.PAGE_WORKFLOW.column_status']"
              [matTooltip]="
                element?.tasks[0]?.data.done
                  ? ('COMPONENT.PAGE_WORKFLOW.status_done' | translate)
                  : ('COMPONENT.PAGE_WORKFLOW.status_not_done' | translate)
              "
              class="w-full h-full flex items-center cursor-default"
            >
              <div
                [ngClass]="{
                  'bg-[#2ecc71]': element?.tasks[0]?.data.done,
                  'bg-[#c0392b]': !element?.tasks[0]?.data.done,
                }"
                class="h-5 w-5 rounded-full mx-auto"
              ></div>
            </div>
          </ng-container>
        </td>
      </ng-container>

      <tr *matHeaderRowDef="displayedColumns" class="!bg-white text-nowrap" mat-header-row></tr>
      <tr *matRowDef="let row; columns: displayedColumns" class="text-nowrap" mat-row></tr>
    </table>
  </div>
  <!-- #endregion -->
</div>
